export default {
    doctype: '',
    docid: 0,
}
